import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core';

import {
  SocialButtonIconContainer,
  getSocialButtonStyles,
} from './SocialButton.styles';

import Button from '@/components/Button';

interface SocialButtonProps {
  icon: React.ReactElement;
  labelKey: string;
  testId: string;
  onClick: () => void;
  marginBottom?: number;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  icon, labelKey, testId, onClick, marginBottom = 8,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Button
      variant="outlined"
      data-testid={testId}
      type="button"
      fullWidth
      rounded
      style={{ ...getSocialButtonStyles(theme), marginBottom }}
      onClick={onClick}
    >
      <SocialButtonIconContainer>{icon}</SocialButtonIconContainer>
      <span>{t(labelKey)}</span>
    </Button>
  );
};

export default SocialButton;
